module.exports = {
  accountUrl: {
    server: '/',
    url: '/',
  },
  cloudMarketUrl: {
    server: 'api.qcintl.woa.com',
    url: 'https://api.qcintl.woa.com',
  },
  headerUrl: {
    server: 'intl.cloud.tencent.com',
    url: 'https://intl.cloud.tencent.com',
  },
  cmsUrl: {
    server: '9.208.69.124',
    url: 'https://9.208.69.124:8080',
  },
  opmUrl: {
    server: 'qcloudintlbackend.tencentyun.com',
    url: 'http://qcloudintlbackend.tencentyun.com',
  },
  transUrl: {
    server: '9.208.69.124',
    url: 'https://9.208.69.124',
  },
  menuAccountUrl: {
    server: 'official.qcintl-portal.tencentyun.com',
    url: 'https://official.qcintl-portal.tencentyun.com',
  },
  proxyUrl: {
    server: 'intl.cloud.tencent.com',
    url: 'https://intl.cloud.tencent.com',
  },
  apiQcintlUrl: {
    server: 'api.qcintl.tencentyun.com',
    url: 'http://api.qcintl.tencentyun.com',
  },
  cmsApi: {
    server: 'cms.qcintl-portal.tencentyun.com',
    url: 'http://cms.qcintl-portal.tencentyun.com:8080',
  },
  cmsPreviewApi: {
    server: 'cms.qcintl-backend.tencentyun.com',
    url: 'http://cms.qcintl-backend.tencentyun.com:8080',
  },
  buyApi: {
    server: 'buy.intl.cloud.tencent.com',
    url: 'https://buy.intl.cloud.tencent.com/cgi/v2',
  },
};